import React from 'react'

import { Box, Paper } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const QuestionSkeleton = () => {
  return (
    <Paper
      component={Box}
      p={2}
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Skeleton variant="rect" width="40%" height={28} />
      <Skeleton variant="rect" width="80%" height={22} />
      <Skeleton variant="rect" width="100%" height={18} />

      <Box display="flex" flexDirection="column" gridGap={8}>
        <Skeleton variant="rect" width="30%" height={22} />
        {[0, 1].map((index) => (
          <Skeleton key={index} variant="rect" width="60%" height={18} />
        ))}
      </Box>

      {[0, 1, 2].map((index) => (
        <Box key={index} display="flex" alignItems="center" gridGap={8}>
          <Skeleton variant="circle" width={20} height={20} />
          <Skeleton variant="rect" width="50%" height={20} />
        </Box>
      ))}
    </Paper>
  )
}

export default QuestionSkeleton
